import { createAction } from 'deox';
import { GET_USER, LOGIN, LOGOUT, SET_TOKEN, SET_USER } from './types';

export const setUser = createAction(SET_USER, (res) => (params) => res(params));
export const getUser = createAction(GET_USER);

export const setToken = createAction(SET_TOKEN, (res) => (params) => res(params));
export const login = createAction(LOGIN, (res) => (params) => res(params));
export const logout = createAction(LOGOUT);
